import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IEpgDetailsState, ViewTypes} from "./IEpgDetailsState.ts";
import api from "../../../newApi/apiNet.ts";
import {IEpgItem} from "../../../interfaces/IEpgItem.ts";
import {IEpgDetailsEpg} from "./IEpgDetailsEpg.ts";

const initialEpgDetailsState: IEpgDetailsState = {
    epgId: 0,
    category: "",
    channelId: -1,
    name: "",
    channelName: "",
    description: "",
    endTimestamp: -1,
    startTimestamp: -1,
    isLoading: false,
    nextEpisodeComing: [],
    selectedView: "MAIN_VIEW"
}

export const epgDetailsSlice = createSlice({
    name: "epgDetails",
    initialState: initialEpgDetailsState,
    reducers: {
        setInitialState: () => initialEpgDetailsState,
        setSelectedView: (state: IEpgDetailsState, action: PayloadAction<ViewTypes>) => {
            state.selectedView = action.payload
        },
        setChannelName: (state: IEpgDetailsState, action: PayloadAction<string>) => {
            state.channelName = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(getEpgDetailsAsync.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getEpgDetailsAsync.fulfilled, (state, action) => {
            state.selectedView = 'MAIN_VIEW';
            state.epgId = action.payload.id;
            state.category = action.payload.category;
            state.name = action.payload.name;
            state.endTimestamp = action.payload.stop_timestamp;
            state.startTimestamp = action.payload.start_timestamp;
            state.description = action.payload.descr;
            state.channelId = action.payload.ch_id;
            state.isLoading = false;
        })
        builder.addCase(getEpgDetailsAsync.rejected, (state) => {
            state.isLoading = false;
        })
        builder.addCase(getEpgDetailsNextEpisodeComingAsync.pending, (state) => {
            state.isLoading = true;
        })
        builder.addCase(getEpgDetailsNextEpisodeComingAsync.fulfilled, (state, action) => {
            state.nextEpisodeComing = action.payload
            state.isLoading = false;
            state.selectedView = "NEXT_EPISODE_COMING_VIEW";
        })
        builder.addCase(getEpgDetailsNextEpisodeComingAsync.rejected, (state) => {
            state.isLoading = false;
        })
    }
})

export const getEpgDetailsAsync = createAsyncThunk<IEpgItem, { id: number, channelName: string }>(
    "epgs/details",
    async ({id, channelName}, {dispatch}) => {
        dispatch(epgDetailsActions.setChannelName(channelName));
        dispatch(epgDetailsActions.setSelectedView('LOADING'));
        const result = await api.getEpg(id);
        return result.data;
    }
);

export const getEpgDetailsNextEpisodeComingAsync = createAsyncThunk<IEpgDetailsEpg[], number>(
    "epgs/details-next-episode-coming",
    async (id, {dispatch}) => {
        dispatch(epgDetailsActions.setSelectedView('LOADING'));
        const result = await api.getNextEpisodesComing(id);
        return result.data;
    }
);

export const epgDetailsActions = epgDetailsSlice.actions;
export default epgDetailsSlice.reducer;